import { render, staticRenderFns } from "./chartProductos.vue?vue&type=template&id=1121da70"
import script from "./chartProductos.vue?vue&type=script&lang=js"
export * from "./chartProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports